// import React from "react";
// import Grid from "@mui/material/Grid";
// // import Typography from "@mui/material/Typography";
// import SaveIcon from '@mui/icons-material/Save';
// import EditIcon from '@mui/icons-material/Edit';
// import CancelIcon from '@mui/icons-material/Close';
// // import {useTheme} from "@mui/material/styles";
// import {useTranslation} from "react-i18next";
// import {DataGrid, GridActionsCellItem, GridRowModes, useGridApiRef,} from '@mui/x-data-grid';

// export default function DatasetColumnEditor(props) {
//     // const theme = useTheme();
//     // init internationalization
//     const {t} = useTranslation();
//     const apiRef = useGridApiRef();

//     const initialRows = props.columnNamesTooLong.map((column, index) => ({
//         id: index + 1,
//         columnNamesTooLong: column,
//     }));

//     const [rows, setRows] = React.useState(initialRows);
//     const [rowModesModel, setRowModesModel] = React.useState({});

//     const handleEditClick = (id) => () => {
//         // change Row Mode in rowModesModel
//         setRowModesModel({...rowModesModel, [id]: {mode: GridRowModes.Edit}});

//         // change Row Mode manually, as it does not work properly otherwise
//         apiRef.current.startRowEditMode({id});
//     };

//     const handleSaveClick = (id) => () => {

//         // change Row Mode in rowModesModel
//         setRowModesModel({...rowModesModel, [id]: {mode: GridRowModes.View}});

//         // change Row Mode manually, as it does not work properly otherwise
//         apiRef.current.stopRowEditMode({id});

//         const rowParams = apiRef.current.getRowParams(id);
//         apiRef.current.publishEvent('rowEditStop', rowParams);
//     };

//     const handleCancelClick = (id) => () => {
//         setRowModesModel({
//             ...rowModesModel,
//             [id]: {mode: GridRowModes.View, ignoreModifications: true},
//         });

//         apiRef.current.stopRowEditMode({id, ignoreModifications: true});

//         const editedRow = rows.find((row) => row.id === id);
//         if (editedRow.isNew) {
//             setRows(rows.filter((row) => row.id !== id));
//         }
//     };

//     const handleRowModesModelChange = (newRowModesModel) => {
//         setRowModesModel(newRowModesModel);
//     };

//     const handleProcessRowUpdate = (updatedRow, originalRow) => {
//         // Find the index of the row that was edited
//         const rowIndex = rows.findIndex((row) => row.id === updatedRow.id);

//         // Replace the old row with the updated row
//         const updatedRows = [...rows];
//         updatedRows[rowIndex] = updatedRow;

//         // Update the state with the new rows
//         setRows(updatedRows);

//         // update the Table with the new rows
//         props.handleTablePreviewRefresh(originalRow.columnNamesTooLong, updatedRow.columnNamesTooLong)

//         // Return the updated row to update the internal state of the DataGrid
//         return updatedRow;
//     };

//     const handleProcessRowUpdateError = (error) => {
//         // Handle Process Row Update Error, is needed for handleProcessRowUpdate
//         console.error('An error occurred during processRowUpdate:', error);
//     };

//     const columns = [
//         {
//             field: "columnNamesTooLong",
//             headerName: t("datasetEditor.ColumnNamesTooLongWarning"),
//             editable: true,
//             align: 'left',
//             headerAlign: 'left',
//             flex: 1,
//         },
//         {
//             field: 'actions',
//             type: 'actions',
//             headerName: 'Actions',
//             width: 100,
//             cellClassName: 'actions',
//             getActions: ({id}) => {
//                 const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

//                 if (isInEditMode) {
//                     return [
//                         <GridActionsCellItem
//                             key="save"
//                             icon={<SaveIcon/>}
//                             label="Save"
//                             sx={{
//                                 color: 'primary.main',
//                             }}
//                             onClick={handleSaveClick(id)}
//                         />,
//                         <GridActionsCellItem
//                             key="cancel"
//                             icon={<CancelIcon/>}
//                             label="Cancel"
//                             className="textPrimary"
//                             onClick={handleCancelClick(id)}
//                             color="inherit"
//                         />,
//                     ];
//                 }

//                 return [
//                     <GridActionsCellItem
//                         icon={<EditIcon/>}
//                         key="edit"
//                         label="Edit"
//                         className="textPrimary"
//                         onClick={handleEditClick(id)}
//                         color="inherit"
//                     />,
//                 ];
//             },
//         },
//     ];

//     return (
//         <Grid
//             sx={{
//                 height: 412,
//                 width: '36%',
//                 '& .actions': {
//                     color: 'text.secondary',
//                 },
//                 '& .textPrimary': {
//                     color: 'text.primary',
//                 },
//                 marginTop: "42px",
//                 backgroundColor: "white"
//             }}
//         >
//             <DataGrid
//                 apiRef={apiRef}
//                 rows={rows}
//                 columns={columns}
//                 editMode="row"
//                 onRowModesModelChange={handleRowModesModelChange}
//                 processRowUpdate={handleProcessRowUpdate}
//                 onProcessRowUpdateError={handleProcessRowUpdateError}

//             />
//         </Grid>
//     );
// }

import React from "react";
import Grid from "@mui/material/Grid";
import SaveIcon from "@mui/icons-material/Save";
import EditIcon from "@mui/icons-material/Edit";
import CancelIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import {
  DataGrid,
  GridActionsCellItem,
  GridRowModes,
  useGridApiRef,
} from "@mui/x-data-grid";

export default function DatasetColumnEditor(props) {
  const { t } = useTranslation();
  const apiRef = useGridApiRef();

  const initialRows = props.columnNamesTooLong.map((column, index) => ({
    id: index + 1,
    columnNamesTooLong: column,
  }));

  const [rows, setRows] = React.useState(initialRows);
  const [rowModesModel, setRowModesModel] = React.useState({});

  const handleEditClick = (id) => () => {
    // change Row Mode in rowModesModel
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });

    // change Row Mode manually, as it does not work properly otherwise
    apiRef.current.startRowEditMode({ id });
  };

  const handleSaveClick = (id) => () => {
    // change Row Mode in rowModesModel
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });

    // change Row Mode manually, as it does not work properly otherwise
    apiRef.current.stopRowEditMode({ id });

    const rowParams = apiRef.current.getRowParams(id);
    apiRef.current.publishEvent("rowEditStop", rowParams);
  };

  const handleCancelClick = (id) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    apiRef.current.stopRowEditMode({ id, ignoreModifications: true });

    const editedRow = rows.find((row) => row.id === id);
    if (editedRow.isNew) {
      setRows(rows.filter((row) => row.id !== id));
    }
  };

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const handleProcessRowUpdate = (updatedRow, originalRow) => {
    // Find the index of the row that was edited
    const rowIndex = rows.findIndex((row) => row.id === updatedRow.id);

    // Replace the old row with the updated row
    const updatedRows = [...rows];
    updatedRows[rowIndex] = updatedRow;

    // Update the state with the new rows
    setRows(updatedRows);

    // update the Table with the new rows
    props.handleTablePreviewRefresh(
      originalRow.columnNamesTooLong,
      updatedRow.columnNamesTooLong
    );

    // Return the updated row to update the internal state of the DataGrid
    return updatedRow;
  };

  const handleProcessRowUpdateError = (error) => {
    // Handle Process Row Update Error, is needed for handleProcessRowUpdate
    console.error("An error occurred during processRowUpdate:", error);
  };

  const columns = [
    {
      field: "columnNamesTooLong",
      headerName: t("datasetEditor.ColumnNamesTooLongWarning"),
      editable: true,
      align: "left",
      headerAlign: "left",
      flex: 1,
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 100,
      cellClassName: "actions",
      getActions: ({ id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <GridActionsCellItem
              key="save"
              icon={<SaveIcon />}
              label="Save"
              sx={{ color: "primary.main" }}
              onClick={handleSaveClick(id)}
            />,
            <GridActionsCellItem
              key="cancel"
              icon={<CancelIcon />}
              label="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(id)}
              color="inherit"
            />,
          ];
        }

        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            key="edit"
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(id)}
            color="inherit"
          />,
        ];
      },
    },
  ];

  return (
    <Grid
      sx={{
        width: "100%",
        minHeight: 400,
        maxWidth: "100%",
        overflowX: "auto",
        backgroundColor: "white",
        // optional - remove top margin so editor snaps below table
        mt: { xs: 2, md: 3 },
      }}
    >
      <DataGrid
        apiRef={apiRef}
        rows={rows}
        columns={columns}
        editMode="row"
        autoHeight // Make grid height adapt to rows for small lists
        onRowModesModelChange={handleRowModesModelChange}
        processRowUpdate={handleProcessRowUpdate}
        onProcessRowUpdateError={handleProcessRowUpdateError}
        disableRowSelectionOnClick
        sx={{
          width: "100%",
        }}
      />
    </Grid>
  );
}
